import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles((theme) => ({
  page: {
    //width: '100%',
    position: 'relative',
    display: 'inline-block',
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
    boxShadow: '2px 4px 6px rgba(0, 0, 0, 0.25)',
  },
  image: {
    width: 'inherit',
    background: '#F1F1FA',
  },
  ocrText: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 4, // NOTE-db-20190521 fix for invisible bottom padding/margin on an image
  },
  magnifier: {
    '& .magnifying-glass': {
      borderColor: theme.palette.primary,
      boxShadow: theme.shadows[4],
    },
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
